import { Http } from "../axios/interceptors";

export const allPreOrdersByCompany = async (param) =>
  Http("GET", "/Orders/PreOrderGetByCompany?", param);

export const getPreOrder = async (idOrder) =>
  Http("GET", `/Orders/PreOrderGet?idOrder=${idOrder}`);

export const preOrderApprove = async (idOrder, idEmployee) =>
  Http(
    "PUT",
    `/Orders/PreOrderApprove?idOrder=${idOrder}&idEmployee=${idEmployee}`,
  );

export const preOrderDecline = async (idOrder) =>
  Http("PUT", `/Orders/PreOrderDecline?idOrder=${idOrder}`);

export const preOrderDelete = async (idOrder) =>
  Http("DELETE", `/Orders/PreOrderDelete?idOrder=${idOrder}`);

export const preOrderAccepted = async (idOrder) =>
  Http("PUT", `/Orders/PreOrderAccepted?idOrder=${idOrder}`);
